/**
 * True when navigation should use a plain <a> (external URL, special scheme, or non-route).
 * Same-origin app paths (e.g. /collections/x) return false, use next/link for those.
 */
export function hrefRequiresNativeAnchor(href: string): boolean {
  const h = href.trim();
  if (!h || h === "#") return true;
  const lower = h.toLowerCase();
  if (lower.startsWith("http://") || lower.startsWith("https://")) return true;
  if (h.startsWith("//")) return true;
  if (lower.startsWith("mailto:") || lower.startsWith("tel:")) return true;
  return false;
}
